import React, { useState, useEffect, useMemo, useRef } from 'react';
import axios from 'axios';
import DashboardLayout from '../Dashboard/layout';
import Swal from 'sweetalert2';
import JoditEditor from 'jodit-react';
import "./CookiesEditor.css";
import { Headings } from '../RegisteredUsersList/ViewRegList';

const CookiesEditor = () => {
  const editorRef = useRef(null);
  const [cookieContent, setCookieContent] = useState('');
  const [loadingCookies, setLoadingCookies] = useState(true);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}api/admin/cookies`)
      .then((response) => {
        if (response.data.cookies && response.data.cookies.content) {
          setCookieContent(response.data.cookies.content);
        } else {
          setCookieContent('');
        }
        setLoadingCookies(false);
      })
      .catch((error) => {
        console.error("Error fetching cookies:", error);
        //const errorMessage = error.response?.data?.message || 'Failed to load cookie policy.';
        //Swal.fire('Error', errorMessage, 'error');
        setLoadingCookies(false);
      });
  }, []);

  const handleCookieSave = async () => {
    if (!cookieContent.trim()) {
      Swal.fire('Error', 'Cookie policy cannot be empty', 'error');
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/admin/cookies`,
        { content: cookieContent }
      );

      if (response.status === 200 || response.status === 201) {
        Swal.fire('Success', response.data.message || 'Cookie policy saved successfully!', 'success')
          .then(() => {
            window.location.reload();
          });
      } else {
        Swal.fire('Error', 'Something went wrong while saving the cookie policy.', 'error');
      }
    } catch (error) {
      console.error('An error occurred while saving the cookie policy:', error);
      Swal.fire('Error', error.response?.data?.message || 'Failed to save cookie policy.', 'error');
    }
  };

  const editorConfig = useMemo(() => ({
    readonly: false,
    placeholder: 'Start typing cookie policy...',
  }), []);

  if (loadingCookies) {
    return <div>Loading cookie policy...</div>;
  }

  return (
    <DashboardLayout>
      <section className="MainDivSec">
        <Headings headspan="Cookies" hedtext=" Policy" />

        <div className="TermEditrDiv">
          <form>
            <JoditEditor
              ref={editorRef}
              value={cookieContent}
              config={editorConfig}
              tabIndex={1}
              className="TermsFormsSec"
              onChange={(newContent) => setCookieContent(newContent)}
            />

            <div className="SubMit">
              <button type="button" onClick={handleCookieSave}>Save</button>
            </div>
          </form>
        </div>
      </section>
    </DashboardLayout>
  );
};

export default CookiesEditor;

